import { useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react'
import toast from 'react-hot-toast';
import { addTmarAndTmprValues as addTmarAndTmprValuesAPI} from 'services/apiComparable';

const useAddTmarTmprValue = () => {
  const queryClient = useQueryClient();
  const{isPending: isAddingValues, isSuccess: isAddedValues, mutate: addTmarAndTmprValues} = useMutation({
    mutationFn: addTmarAndTmprValuesAPI,
    onSuccess:(data)=>{
        queryClient.setQueryData(['newRelativeCompData'],data)
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isAddingValues, isAddedValues, addTmarAndTmprValues}
}

export default useAddTmarTmprValue